import React, { useState } from "react";
import FieldCheckboxComponent from "../../FieldCheckbox/FieldCheckbox";
import { FormattedMessage } from "../../../util/reactIntl";
import css from './FeesInputFields.module.css';
import IconCollection from "../../IconCollection/IconCollection";
import { useDispatch } from "react-redux";
import { manageDisableScrolling } from "../../../ducks/ui.duck";
import { Modal, Map } from "../../../components";


const MapView = ({ isMapView, setIsMapView, onManageDisableScrolling, listing}) => {
    const { geolocation, publicData } = listing?.attributes || {};
    const { location } = publicData || {};
    
    const mapProps = geolocation && geolocation.lat && geolocation.lng
    ? { address: location?.address, center: geolocation }
    : null
  
    return (
      <Modal
        id="PickupReturnModal"
        onManageDisableScrolling={onManageDisableScrolling}
        isOpen={isMapView}
        onClose={() => setIsMapView(false)}
        className={css.pickupReturnModal}
        title={<FormattedMessage id="OrderBreakdown.pickupAndReturn" />}
      >
        {geolocation && geolocation.lat && geolocation.lng ? (
          <Map className={css.map} {...mapProps} />
        ) : (
          <div>
            <p> No data available.</p>
          </div>)}
      </Modal>
    );
  };

const OtherBookingFields = (props) => {
    const { isPickupAtOwnerLocation, showHeading, intl, fetchLineItemsInProgress, listing } = props;
    const dispatch = useDispatch();
    const [isMapView, setIsMapView] = useState(false);
    const onManageDisableScrolling = (modalId) => dispatch(manageDisableScrolling(modalId));

    return (
        <div className={css.otherBookingFieldsContainer}>
            <MapView isMapView={isMapView} setIsMapView={setIsMapView} onManageDisableScrolling={onManageDisableScrolling} listing={listing} />
            {showHeading && <h5 className={css.title}>
                <FormattedMessage id="OtherBookingFields.title" />
            </h5>}
            <div className={css.otherBookingFields}>
                {isPickupAtOwnerLocation && (
                    <div>
                        <div className={css.pickupOption}>
                            <FieldCheckboxComponent
                                id="pickupAtOwnerLocation"
                                name="pickupAtOwnerLocation"
                                label={intl.formatMessage({
                                    id: "OtherBookingFields.fieldPickupAtOwnerLocation.label"
                                })}
                                value={true}
                                disabled={fetchLineItemsInProgress}
                            />
                            <button type="button" onClick={() => setIsMapView(true)}>
                                <IconCollection className={css.pinIcon} name="location-pin" />
                            </button>
                        </div>
                        <FieldCheckboxComponent
                            id="returnAtOwnerLocation"
                            name="returnAtOwnerLocation"
                            label={intl.formatMessage({
                                id: "OtherBookingFields.fieldReturnAtOwnerLocation.label"
                            })}
                            value={true}
                            disabled={fetchLineItemsInProgress}
                        />
                    </div>)}
            </div>
        </div>
    )
}

export default OtherBookingFields;